import * as types from '../mutations-types'

import { setLogHistory } from '../../utils/api'

import { eventsLogHistory } from '../../utils/eventsLogHistory'
import getInfoUserFromTokens from '../../utils/getInfoUserFromTokens'

// STATE
const state = {
  modelTypeSearchedFilters: '',
  payloadSearchedFilters: {}
}

// GETTERS
const getters = {
  modelTypeSearchedFilters: state => state.modelTypeSearchedFilters,
  payloadSearchedFilters: state => state.payloadSearchedFilters
}

// MUTATIONS
const mutations = {
  [types.SET_MODEL_TYPE_SEARCHED_FILTERS](state, value) {
    state.modelTypeSearchedFilters = state.modelTypeSearchedFilters + value
  },
  [types.SET_PAYLOAD_SEARCHED_FILTERS](state, payload) {
    state.payloadSearchedFilters = {...state.payloadSearchedFilters, ...payload}
  },
  [types.INIT_MODEL_TYPE_SEARCHED_FILTERS](state) {
    state.modelTypeSearchedFilters = ''
  },
  [types.INIT_PAYLOAD_SEARCHED_FILTERS](state) {
    state.payloadSearchedFilters = {}
  }
}

// ACTIONS
const actions = {
  setLogHistoryAuth({state}, event) {
    return new Promise(async(resolve, reject) => {
      try {
        const { email, whoId, whoName, roleToSend } = getInfoUserFromTokens()

        const dataToLog = {
          'event': event,
          'event_description': eventsLogHistory.get(event),
          'model_type': 'users',
          'product': 'micro-avl',
          'user_role': roleToSend,
          'who_email': email,
          'who_id': whoId,
          'who_name': whoName,
          'who_type': 'auth0'
        }
        await setLogHistory(dataToLog)
          .then(data => {
            resolve(data)
          })
          .catch(error => {
            reject(new Error(error.response))
          })
      } catch (error) {
        console.error(error)
        reject(error)
      }
    })
  },
  setLogHistoryFront({state}, payload) {
    return new Promise(async(resolve, reject) => {
      try {
        const { email, whoId, whoName, roleToSend } = getInfoUserFromTokens()

        const dataToLog = {
          'event': payload.event,
          'event_description': payload.eventDescription,
          'data_action': payload.dataAction,
          'model_id': String(payload.modelId),
          'model_type': payload.modelType,
          'product': payload.product,
          'user_role': roleToSend,
          'who_email': email,
          'who_id': whoId,
          'who_name': whoName,
          'who_type': 'auth0'
        }
        await setLogHistory(dataToLog)
          .then(data => {
            resolve(data)
          })
          .catch(error => {
            reject(new Error(error.response))
          })
      } catch (error) {
        console.error(error)
        reject(error)
      }
    })
  },
  setModelTypeSearchedFilters({commit}, value) {
    commit(types.SET_MODEL_TYPE_SEARCHED_FILTERS, value)
  },
  setPayloadSearchedFilters({commit}, payload) {
    commit(types.SET_PAYLOAD_SEARCHED_FILTERS, payload)
  },
  initSearchedFiltersStates({commit}) {
    commit(types.INIT_MODEL_TYPE_SEARCHED_FILTERS)
    commit(types.INIT_PAYLOAD_SEARCHED_FILTERS)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/logsHistory.js